import { createContext, useContext } from 'react';

import { useFetchAccessToken } from '~/hooks/auth/useGetAccessToken';
import { useGetCurrentToken } from '~/hooks/auth/useGetCurrentToken';
import { useVerifyToken } from '~/hooks/auth/useVerifyToken';
import { useGetAccount } from '~/hooks/web3/useGetAccount';

import { GameAuthenticationProviderTypes } from './GameAuthenticationProvider.types';

const GameAuthenticationContext = createContext(
  {} as GameAuthenticationProviderTypes
);

const GameAuthenticationContextProvider = ({
  children,
  accessTokenRequired,
}: {
  children: any;
  accessTokenRequired?: boolean;
}) => {
  const { data: connectedAccount } = useGetAccount();
  useVerifyToken(connectedAccount?.address, accessTokenRequired);
  const {
    // data: tokenGenerated,
    isLoading: isLoadingAccessToken,
    isSuccess,
    mutate: generateAccessToken,
  } = useFetchAccessToken({
    walletAddress: connectedAccount?.address!,
  }
  );

  const { data: tokenStored } = useGetCurrentToken({
    address: connectedAccount?.address!,
    enabled: Boolean(connectedAccount?.address),
  }
  );

  const token = tokenStored;
  return (
    <GameAuthenticationContext.Provider
      value={{
        connectedWallet: connectedAccount?.address || null,
        accessToken: token,
        isLoadingAccessToken,
        isSuccess,
        generateAccessToken,
      }}
    >
      {children}
    </GameAuthenticationContext.Provider>
  );
};

export default GameAuthenticationContextProvider;

export function useGameAuthentication(): GameAuthenticationProviderTypes {
  return useContext(GameAuthenticationContext);
}
